<template>
  <v-card>
    <v-card-title>
      <v-icon color="primary">mdi-radar</v-icon>
      <span class="pl-2">On-demand operations</span>
      <v-spacer />
      <v-btn icon :loading="loading" @click="loadRequests">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle>Shared dispatch activity for Ride and Delivery</v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="4">
          <v-select v-model="filters.service_code" :items="services" clearable outlined dense label="Service" @change="loadRequests" />
        </v-col>
        <v-col cols="12" sm="4">
          <v-select v-model="filters.status" :items="statuses" clearable outlined dense label="Status" @change="loadRequests" />
        </v-col>
      </v-row>
      <v-alert v-if="error" type="error" outlined dense>{{ error }}</v-alert>
      <v-data-table
        :headers="headers"
        :items="requests"
        :loading="loading"
        :server-items-length="total"
        :options.sync="options"
        @update:options="loadRequests"
      >
        <template #item.service_code="{ item }">
          <v-chip small :color="item.service_code === 'ride' ? 'primary' : 'success'" dark>
            {{ item.service_code }}
          </v-chip>
        </template>
        <template #item.status="{ item }">
          <v-chip small outlined>{{ readable(item.status) }}</v-chip>
        </template>
        <template #item.customer="{ item }">{{ item.customer ? item.customer.name : '-' }}</template>
        <template #item.provider="{ item }">{{ item.assigned_provider ? item.assigned_provider.name : 'Searching' }}</template>
        <template #item.fare="{ item }">{{ fare(item) }}</template>
        <template #item.rating="{ item }">
          <span v-if="item.review"><v-icon small color="amber">mdi-star</v-icon> {{ item.review.rating }}/5</span><span v-else>-</span>
        </template>
        <template #item.report="{ item }">
          <v-chip v-if="item.report" small :color="item.report.severity === 'high' ? 'error' : 'warning'" dark>{{ readable(item.report.reason) }} • {{ item.report.status }}</v-chip><span v-else>-</span>
        </template>
        <template #item.parcel="{ item }">
          <span v-if="item.delivery">{{ item.delivery.quote.parcel_size }}<span v-if="item.delivery.quote.is_fragile"> • fragile</span></span>
          <span v-else>-</span>
        </template>
        <template #item.proof="{ item }"><a v-if="item.delivery && item.delivery.proof_photo_url" :href="item.delivery.proof_photo_url" target="_blank" rel="noopener">View proof</a><span v-else>-</span></template>
        <template #item.requested_at="{ item }">{{ formatDate(item.requested_at) }}</template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      error: '',
      requests: [],
      total: 0,
      options: { page: 1, itemsPerPage: 30 },
      filters: { service_code: null, status: null },
      services: [{ text: 'Ride', value: 'ride' }, { text: 'Delivery', value: 'delivery' }],
      statuses: ['searching', 'offered', 'assigned', 'provider_arriving', 'in_progress', 'completed', 'cancelled', 'no_provider'],
      headers: [
        { text: 'Service', value: 'service_code' },
        { text: 'Status', value: 'status' },
        { text: 'Customer', value: 'customer' },
        { text: 'Provider', value: 'provider' },
        { text: 'Fare', value: 'fare' },
        { text: 'Rating', value: 'rating' },
        { text: 'Report', value: 'report' },
        { text: 'Parcel', value: 'parcel' },
        { text: 'Proof', value: 'proof' },
        { text: 'Pickup', value: 'pickup_address' },
        { text: 'Destination', value: 'destination_address' },
        { text: 'Requested', value: 'requested_at' },
      ],
    };
  },
  mounted() { this.loadRequests(); },
  methods: {
    readable(value) { return String(value || '').replace(/_/g, ' '); },
    fare(item) {
      const record = item.ride || item.delivery;
      return record ? `${record.currency || 'SLE'} ${Number(record.quoted_fare || 0).toFixed(2)}` : '-';
    },
    formatDate(value) { return value ? new Date(value).toLocaleString() : '-'; },
    loadRequests() {
      this.loading = true;
      this.error = '';
      axios.get('/admin/on-demand/requests', {
        params: {
          page: this.options.page,
          per_page: this.options.itemsPerPage,
          ...this.filters,
        },
      }).then((response) => {
        this.requests = response.data.data || [];
        this.total = response.data.total || 0;
      }).catch((error) => {
        this.error = error.response?.data?.message || 'Unable to load on-demand operations.';
      }).then(() => { this.loading = false; });
    },
  },
};
</script>
